// extracted by mini-css-extract-plugin
export default {"tabs":"tabs__-ab10d9","tab":"tab__-ab10d9","active":"active__-ab10d9"};